import crypto from 'crypto-js';
import getUniqueId from './getUniqueId';

const NONCE_NAMESPACE = 'AMEX';
const GEN_HMAC_DELIMITER = '\n';
const GEN_AUTH_DELIMITER = ',';
const AUTH_PREFIX = 'MAC ';

type Config = {
  clientKey: string;
  clientSecret: string;
  httpMethod: string;
  resourcePath: string;
  host: string;
  port: string;
};

const apigeeHmac = (config: Config) => {
  const { clientKey, clientSecret, httpMethod, resourcePath, host } = config;
  const port = Number.parseInt(config.port, 10).toString(10);

  const ts = new Date().getTime();
  const nonce = `${NONCE_NAMESPACE}:${ts.toString(10)}:${getUniqueId()}`;

  const generateBodyHash = (body: string) => {
    const hmac = crypto.HmacSHA256(body, clientSecret);
    return crypto.enc.Base64.stringify(hmac);
  };

  const createHmacMessage = (bodyHash: string) =>
    [ts.toString(10), nonce, httpMethod.toUpperCase(), resourcePath, host, port, bodyHash].join(
      GEN_HMAC_DELIMITER
    ) + GEN_HMAC_DELIMITER;

  const generateHMAC = (bodyHash: string) => {
    const hmacMessage = createHmacMessage(bodyHash);
    const hmac = crypto.HmacSHA256(hmacMessage, clientSecret);
    return crypto.enc.Base64.stringify(hmac);
  };

  const renderAuthorization = (body: string) => {
    const authParts = [];
    authParts.push(`id="${clientKey}"`);
    authParts.push(`ts="${ts}"`);
    authParts.push(`nonce="${nonce}"`);
    const bodyHash = generateBodyHash(body);
    authParts.push(`bodyhash="${bodyHash}"`);
    authParts.push(`mac="${generateHMAC(bodyHash)}"`);
    return AUTH_PREFIX + authParts.join(GEN_AUTH_DELIMITER);
  };

  return { render: renderAuthorization };
};

export default apigeeHmac;
